import { render } from "./contatos.vue?vue&type=template&id=4312b59c"
import script from "./contatos.vue?vue&type=script&lang=js"
export * from "./contatos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__